module.exports = __webpack_public_path__ + "img/funnel-andrew.353b1658.png";